import { FileUploadValidation } from './file-upload/FileUpload.types';

/** Maximum CSV file size for bulk label value upload (1 MiB). */
export const MAX_LABEL_VALUES_CSV_FILE_SIZE_BYTES = 1024 * 1024;

const LABEL_VALUES_CSV_FILE_EXTENSION = '.csv';

const LABEL_VALUES_CSV_MIME_TYPES = new Set([
	'text/csv',
	'application/csv',
	'text/comma-separated-values'
]);

export const LABEL_VALUES_CSV_FILE_UPLOAD_VALIDATION: FileUploadValidation = {
	accept: '.csv,text/csv',
	maxFileSizeBytes: MAX_LABEL_VALUES_CSV_FILE_SIZE_BYTES,
	allowedExtensions: [LABEL_VALUES_CSV_FILE_EXTENSION],
	allowedMimeTypes: LABEL_VALUES_CSV_MIME_TYPES
};
